import { Empty, Timeline } from "antd"
import { ClockCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { LogItem } from "./LogItem";
import { ActivityLogAction } from "src/common/models/activityLog";
import { SystemDescriptions } from "src/common/descriptions";

interface Props {
    records: {
        description: string
        date: string
        type: ActivityLogAction
    }[]
}

const commonDescriptions = SystemDescriptions.PAGES.COMMON

export const getActivityLogActionLabel = (action: ActivityLogAction): string => {
    const dictionaryOfActionDescriptions = {
        [ActivityLogAction.CREATE]: commonDescriptions.ACTIVITY_LOG_ACTIONS.CREATE,
        [ActivityLogAction.UPDATE]: commonDescriptions.ACTIVITY_LOG_ACTIONS.UPDATE,
        [ActivityLogAction.DELETE]: commonDescriptions.ACTIVITY_LOG_ACTIONS.DELETE,
        [ActivityLogAction.ACTIVATED]: commonDescriptions.ACTIVITY_LOG_ACTIONS.ACTIVATED,
        [ActivityLogAction.INACTIVATED]: commonDescriptions.ACTIVITY_LOG_ACTIONS.INACTIVATED,
    }

    return dictionaryOfActionDescriptions[action] || "Unknown action"
}

export const TimeLine = (props: Props) => {

    const dictionaryOfIcons = {
        [ActivityLogAction.CREATE]: <ClockCircleOutlined />,
        [ActivityLogAction.UPDATE]: <ClockCircleOutlined />,
        [ActivityLogAction.DELETE]: <ClockCircleOutlined />,
        [ActivityLogAction.ACTIVATED]: <ClockCircleOutlined />,
        [ActivityLogAction.INACTIVATED]: <ClockCircleOutlined />,
    }

    const dictionaryOfColors = {
        [ActivityLogAction.CREATE]: 'blue',
        [ActivityLogAction.UPDATE]: 'green',
        [ActivityLogAction.DELETE]: 'red',
        [ActivityLogAction.ACTIVATED]: 'green',
        [ActivityLogAction.INACTIVATED]: 'red',
    }

    const DEFAULT_ICON = <MinusCircleOutlined />
    const DEFAULT_COLOR = 'black'

    return (
        props.records.length > 0
            ? <Timeline
                items={props.records.map(record => {
                    return {
                        dot: dictionaryOfIcons[record.type] ?? DEFAULT_ICON,
                        color: dictionaryOfColors[record.type] ?? DEFAULT_COLOR,
                        children: <LogItem
                            description={record.description}
                            date={record.date}
                        />,
                    }
                })}
            />
            : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    )
}
